import { cn } from '../../lib/utils'
import { VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const inputVariants = cva(
  'flex h-8 w-full px-3 rounded-md border border-gray-200 bg-white text-sm placeholder:text-gray-500 transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'focus:border-[#F7931A] focus:ring-1 focus:ring-[#F7931A]', 
        noFocus: 'focus:outline-none',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
